import type { GatsbyBrowser } from 'gatsby';
import { INSURANCE, TAKAFUL } from './src/constants';
import Layout from './src/components/Layout/Layout';
import { initDatadog } from './src/utility/datadog';
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return <Layout>{element}</Layout>;
};
export const onClientEntry = () => {
  const paths = window.location.pathname.split('/');
  const routeSection = paths.find(
    (path) => path === INSURANCE || path === TAKAFUL,
  );
  if (routeSection === INSURANCE) {
    initDatadog();
  }
};
export const onInitialClientRender = () => {
  if (typeof document === 'object') {
    document.getElementById('___loader')!.style.display = 'none';
  }
};
